// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/vision_cast_member.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/vision_cast_member.proto.
 */
export const file_vision_shotlist_v1_vision_cast_member: GenFile = /*@__PURE__*/
  fileDesc("Cit2aXNpb24vc2hvdGxpc3QvdjEvdmlzaW9uX2Nhc3RfbWVtYmVyLnByb3RvEhlwcm90b3MudmlzaW9uLnNob3RsaXN0LnYxIqABChBWaXNpb25DYXN0TWVtYmVyEg8KB2Nhc3RfaWQYASABKAkSDAoEbmFtZRgCIAEoCRINCgVjb2xvchgDIAEoCRIuCgpjcmVhdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcGIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.shotlist.v1.VisionCastMember
 */
export type VisionCastMember = Message<"protos.vision.shotlist.v1.VisionCastMember"> & {
  /**
   * @generated from field: string cast_id = 1;
   */
  castId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string color = 3;
   */
  color: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.VisionCastMember.
 * Use `create(VisionCastMemberSchema)` to create a new message.
 */
export const VisionCastMemberSchema: GenMessage<VisionCastMember> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_vision_cast_member, 0);

